import React from "react";
import ReactDOM from "react-dom/client";
import App from "./lib/controllers/app/App";
import { Provider } from "react-redux";
import store from "./lib/pages/home/redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
